<template>
  <div>
    <h1 class="text-success">Formulario Tipo de  Vacuna para Niños</h1>
    <div class="alert alert-info" role="alert">
      <strong>Nota:</strong> Este formulario agregará los tipos de vacunas en el Esquema de vacunación para niños/as.
    </div>
    <div class="mt-4">
      <button @click="showCreateForm" class="btn btn-primary">Agregar Tipo Vacuna</button>
    </div>

    <!-- Lista de VacunaTipoNiño en una tabla -->
    <div class="table-responsive mt-3">
      <table class="table table-bordered">
        <thead class="thead-light">
          <tr>
            <th>Tipo</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="vacunaTipoNiño in vacunaTipoNiñoList" :key="vacunaTipoNiño._id">
            <td>{{ vacunaTipoNiño.tipo }}</td>
            <td>
              <div class="btn-group" role="group">
                <button @click="editVacunaTipoNiño(vacunaTipoNiño)" class="btn btn-warning btn-sm">Editar</button>
                <button @click="deleteVacunaTipoNiño(vacunaTipoNiño._id)" class="btn btn-danger btn-sm">Eliminar</button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Formulario de creación/editar -->
    <div v-if="showForm" class="mt-4">
      <h2 class="h4">{{ isEditing ? 'Editar VacunaTipoNiño' : 'Agregar VacunaTipoNiño' }}</h2>
      <form @submit.prevent="isEditing ? updateVacunaTipoNiño() : createVacunaTipoNiño()" class="form-inline">
        <div class="form-group mr-2">
          <label for="tipo" class="mr-2">Tipo</label>
          <input v-model="formData.tipo" type="text" id="tipo" required class="form-control form-control-lg" />
        </div>
        <div class="btn-group">
          <button type="submit" class="btn btn-primary">{{ isEditing ? 'Guardar Cambios' : 'Agregar' }}</button>
          <button @click="cancelEdit" class="btn btn-secondary">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  data() {
    return {
      vacunaTipoNiñoList: [],
      showForm: false,
      formData: {
        tipo: '',
      },
      isEditing: false,
      editingVacunaTipoNiñoId: null,
    };
  },
  methods: {
    async fetchVacunaTipoNiño() {
      try {
        const response = await axios.get(`${BASE_URL}/api/vacunaninotipo`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        this.vacunaTipoNiñoList = response.data;
      } catch (error) {
        console.error('Error al obtener VacunaTipoNiño:', error);
      }
    },
    showCreateForm() {
      this.showForm = true;
      this.isEditing = false;
      this.formData = {
        tipo: '',
      };
    },
    async createVacunaTipoNiño() {
      try {
        await axios.post(`${BASE_URL}/api/vacunaninotipo`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Guardada!',
          text: 'La información de VacunaTipoNiño ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchVacunaTipoNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al guardar la información de VacunaTipoNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    clearFields() {
      this.formData = {
        tipo: '',
      };
    },
    deleteVacunaTipoNiño(id) {
      swal({
        title: '¿Estás seguro?',
        text: 'Una vez eliminado, no podrás recuperar este registro.',
        icon: 'warning',
        buttons: ['Cancelar', 'Eliminar'],
        dangerMode: true,
      })
      .then((confirmation) => {
        if (confirmation) {
          this.performVacunaTipoNiñoDeletion(id);
        }
      });
    },
    async performVacunaTipoNiñoDeletion(id) {
      try {
        await axios.delete(`${BASE_URL}/api/vacunaninotipo/${id}`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Eliminada!',
          text: 'La información de VacunaTipoNiño ha sido eliminada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.fetchVacunaTipoNiño();
      } catch (error) {
        swal({
          title: 'Error',
          text: 'Hubo un error al eliminar la información de VacunaTipoNiño.',
          icon: 'error',
          button: 'OK',
        });
      }
    },
    editVacunaTipoNiño(vacunaTipoNiño) {
      this.isEditing = true;
      this.editingVacunaTipoNiñoId = vacunaTipoNiño._id;
      this.formData.tipo = vacunaTipoNiño.tipo;
      this.showForm = true;
    },
    async updateVacunaTipoNiño() {
      try {
        await axios.put(`${BASE_URL}/api/vacunaninotipo/${this.editingVacunaTipoNiñoId}`, this.formData, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        });
        swal({
          title: '¡Información Actualizada!',
          text: 'La información de VacunaTipoNiño ha sido actualizada correctamente.',
          icon: 'success',
          button: 'OK',
        });
        this.clearFields();
        this.fetchVacunaTipoNiño();
        this.showForm = false;
      } catch (error) {
        swal({
          title: 'Error',
          text: `Hubo un error al editar la información de VacunaTipoNiño. \n ${error.response.data.message}.`,
          icon: 'error',
          button: 'OK',
        });
      }
    },
    cancelEdit() {
      this.showForm = false;
      this.isEditing = false;
      this.clearFields();
    },
  },
  mounted() {
    this.fetchVacunaTipoNiño();
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
